import { render, staticRenderFns } from "./symbols.vue?vue&type=template&id=3419d500&"
import script from "./symbols.vue?vue&type=script&lang=js&"
export * from "./symbols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports